import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _typeof from "@babel/runtime/helpers/typeof";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.to-string-tag.js";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from "@faire/web--source/common/makeObservable";
import { createMediaQueryString, MIN_WIDTH_BREAKPOINTS } from "@faire/web--source/common/media";
import Viewport from "@faire/web--source/common/Viewport";
import { computed } from "mobx";
export var Media2Strings = /*#__PURE__*/function () {
  function Media2Strings() {
    var viewport = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Viewport.getDefault();
    _classCallCheck(this, Media2Strings);
    this.viewport = viewport;
    this.canHover = "@media (hover: hover)";
    makeObservable(this);
  }
  return _createClass(Media2Strings, [{
    key: "responsiveBreakpoints",
    get: function get() {
      var _this$viewport$minWid;
      return {
        mobile: {
          max: "".concat(this.viewport.minWidthBreakpoints.tablet - 1, "px")
        },
        tablet: {
          min: "".concat(this.viewport.minWidthBreakpoints.tablet, "px"),
          max: "".concat(this.viewport.minWidthBreakpoints.desktop - 1, "px")
        },
        desktop: {
          min: "".concat(this.viewport.minWidthBreakpoints.desktop, "px"),
          max: "".concat(this.viewport.minWidthBreakpoints.xlarge - 1, "px")
        },
        xlarge: {
          min: "".concat(this.viewport.minWidthBreakpoints.xlarge, "px"),
          max: "".concat(((_this$viewport$minWid = this.viewport.minWidthBreakpoints.xxlarge) !== null && _this$viewport$minWid !== void 0 ? _this$viewport$minWid : MIN_WIDTH_BREAKPOINTS.XXLARGE) - 1, "px")
        },
        xxlarge: {
          min: "".concat(this.viewport.minWidthBreakpoints.xxlarge, "px")
        },
        tabletAndBelow: {
          max: "".concat(this.viewport.minWidthBreakpoints.desktop - 1, "px")
        },
        tabletAndAbove: {
          min: "".concat(this.viewport.minWidthBreakpoints.tablet, "px")
        },
        desktopAndAbove: {
          min: "".concat(this.viewport.minWidthBreakpoints.desktop, "px")
        },
        xLargeAndAbove: {
          min: "".concat(this.viewport.minWidthBreakpoints.xlarge, "px")
        }
      };
    }
  }, {
    key: "mobile",
    get: function get() {
      return createMediaQueryString(this.responsiveBreakpoints.mobile);
    }
  }, {
    key: "tablet",
    get: function get() {
      return createMediaQueryString(this.responsiveBreakpoints.tablet);
    }
  }, {
    key: "desktop",
    get: function get() {
      return createMediaQueryString(this.responsiveBreakpoints.desktop);
    }
  }, {
    key: "xlarge",
    get: function get() {
      return createMediaQueryString(this.responsiveBreakpoints.xlarge);
    }
  }, {
    key: "xxlarge",
    get: function get() {
      return createMediaQueryString(this.responsiveBreakpoints.xxlarge);
    }
  }, {
    key: "tabletAndAbove",
    get: function get() {
      return createMediaQueryString(this.responsiveBreakpoints.tabletAndAbove);
    }
  }, {
    key: "tabletAndBelow",
    get: function get() {
      return createMediaQueryString(this.responsiveBreakpoints.tabletAndBelow);
    }
  }, {
    key: "desktopAndAbove",
    get: function get() {
      return createMediaQueryString(this.responsiveBreakpoints.desktopAndAbove);
    }
  }, {
    key: "xLargeAndAbove",
    get: function get() {
      return createMediaQueryString(this.responsiveBreakpoints.xLargeAndAbove);
    }
  }]);
}();
__decorate([computed], Media2Strings.prototype, "responsiveBreakpoints", null);
__decorate([computed], Media2Strings.prototype, "mobile", null);
__decorate([computed], Media2Strings.prototype, "tablet", null);
__decorate([computed], Media2Strings.prototype, "desktop", null);
__decorate([computed], Media2Strings.prototype, "xlarge", null);
__decorate([computed], Media2Strings.prototype, "xxlarge", null);
__decorate([computed], Media2Strings.prototype, "tabletAndAbove", null);
__decorate([computed], Media2Strings.prototype, "tabletAndBelow", null);
__decorate([computed], Media2Strings.prototype, "desktopAndAbove", null);
__decorate([computed], Media2Strings.prototype, "xLargeAndAbove", null);